import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { lincolnCityConfig } from "./data";

export default function LincolnCityPage() {
  return <OregonCityPageTemplate config={lincolnCityConfig} />;
}